import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { CustomerPlacardComponent } from './customer-placard.component';
import { HistoricalCustomerPlacardModalComponent } from './historical-customer-placard-modal.component';
import { HistoricalCustomerPlacardComponent } from './historical-customer-placard.component';

@NgModule({
    declarations: [
        CustomerPlacardComponent,
        HistoricalCustomerPlacardComponent,
        HistoricalCustomerPlacardModalComponent
    ],
    providers: [],
    imports: [
        CommonModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        CustomerPlacardComponent,
        HistoricalCustomerPlacardComponent,
        HistoricalCustomerPlacardModalComponent
    ]
})

export class CustomerPlacardModule { }
